import React from "react";
import ReactDOM from "react-dom";
import { ApolloProvider } from "@apollo/client";
import client from "./apollo-client";
import App from "./App";
import "carbon-components/css/carbon-components.min.css";

console.log("🚀 React App is loading...");
ReactDOM.render(
  <ApolloProvider client={client}>
    <App />
  </ApolloProvider>,
  document.getElementById("root"),
);
